export const genMeta = ({
  title,
  description,
  keywords,
  image,
  other,
  isRoot = false,
}: {
  title: string;
  description?: string;
  image?: string;
  keywords?: string;
  other?: Record<string, string>[];
  isRoot?: boolean;
}) => ({
  meta: [
    { title },
    { name: 'description', content: description },
    { name: 'twitter:title', content: title },
    { name: 'twitter:description', content: description },
    { name: 'og:type', content: 'website' },
    { name: 'og:title', content: title },
    { name: 'og:description', content: description },
    ...(keywords ? [{ name: 'keywords', content: keywords }] : []),
    {
      name: 'viewport',
      content:
        'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover',
    },
    ...(image ? [{ name: 'og:image', content: image }] : []),
    ...(other ? other : []),
  ],
  ...(image
    ? [
        {
          links: [
            {
              rel: 'image_src',
              href: image,
            },
          ],
        },
      ]
    : []),
  ...(isRoot
    ? {
        scripts: [
          {
            async: true,
            src: 'https://www.googletagmanager.com/gtag/js?id=G-2GJCS2F15K',
          },
          {
            children: `
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                gtag('config', 'G-2GJCS2F15K');
              `,
          },
          //         {
          //           children: `
          //             !function(f,b,e,v,n,t,s)
          // {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          // n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          // if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          // n.queue=[];t=b.createElement(e);t.async=!0;
          // t.src=v;s=b.getElementsByTagName(e)[0];
          // s.parentNode.insertBefore(t,s)}(window, document,'script',
          // 'https://connect.facebook.net/en_US/fbevents.js');
          // fbq('init', '1665848577630207');
          // fbq('track', 'PageView');
          //         `,
          //         },
        ],
      }
    : {}),
});
